import "./App.css";
import React from "react";
import Routess from "./routes/Routess";

function App() {
  return (
    <>
      <Routess/>
    </>
  );
}

export default App;
